import React from 'react';
import { GlobalConfiguration } from '../../../models/GlobalConfiguration';
import StyledFieldDescription from '../../styles/StyledFieldDescription';
import { StyledInput } from '../../styles/StyledInputs';
import StyledSection from '../../styles/StyledSection';
import { StyledFieldRow, StyledHeading, StyledLabel } from '../../styles/styles';
import ConfigFieldLabel from './ConfigFieldLabel';
import { GLOBAL_CONFIG_FIELD_HELP, GLOBAL_CONFIG_FIELD_LABELS } from './globalConfigFieldConfig';

type VeraExcludedUrlsSectionProps = {
  config: GlobalConfiguration;
  dirtyFields: Set<string>;
  onChange: (field: string, value: unknown) => void;
};

export default function VeraExcludedUrlsSection({
  config,
  dirtyFields,
  onChange,
}: VeraExcludedUrlsSectionProps) {
  return (
    <StyledSection tone="tone1">
      <StyledHeading tone="tone1" headerVariant="heading2">
        Excluded URLs
      </StyledHeading>

      <StyledFieldRow stacked sx={{ mb: 2 }} data-field="veraGoogleSearchExcludeDomains">
        <StyledLabel stacked>
          <ConfigFieldLabel
            fieldKey="veraGoogleSearchExcludeDomains"
            label={GLOBAL_CONFIG_FIELD_LABELS.veraGoogleSearchExcludeDomains}
            dirtyFields={dirtyFields}
            tooltip={GLOBAL_CONFIG_FIELD_HELP.veraGoogleSearchExcludeDomains}
          />
        </StyledLabel>
        <StyledFieldDescription stacked>
          Extra domains to drop from Vera&apos;s Google Search results, added on top of a built-in
          baseline (major social networks, forums and UGC sites). One root domain per line;
          &quot;www.&quot; and any path are ignored. Applies to investor global Vera chat and admin
          assist.
        </StyledFieldDescription>
        <StyledInput
          multiline
          minRows={4}
          value={config.veraGoogleSearchExcludeDomains ?? ''}
          onChange={(event) => onChange('veraGoogleSearchExcludeDomains', event.target.value)}
          placeholder={'competitor.com\nuntrusted-news.example'}
        />
      </StyledFieldRow>
    </StyledSection>
  );
}
